import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import {
  GuidelineFormValues,
  ThresholdType,
} from '@/pages/funds/ic-guidelines-v2/components/edit-guideline-form/schema'
import { ThresholdTypes } from '@/pages/funds/ic-guidelines-v2/components/edit-guideline-form/schema'

export const ThresholdTypeField: React.FC = () => {
  const { control, setValue } = useFormContext<GuidelineFormValues>()

  return (
    <FormField
      name="threshold_type"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Threshold Type</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              options={ThresholdTypes.map((t) => ({ label: t, value: t }))}
              value={value}
              setValue={(val) => {
                const nextThresholdType = val as ThresholdType

                setValue('threshold_type', nextThresholdType, {
                  shouldValidate: true,
                  shouldDirty: true,
                })
              }}
            />
          </FormItem>
        )
      }}
    />
  )
}
